import type { Guest, Invoice } from "@/types/camping";

export interface BillingAddressFormState {
  override: boolean;
  company_name: string;
  name: string;
  street: string;
  postal_code: string;
  city: string;
  country_code: string;
}

export interface InvoiceBillingAddressPayload {
  override: boolean;
  company_name: string | null;
  name: string;
  street: string;
  postal_code: string;
  city: string;
  country_code: string;
}

export function guestToBillingAddressForm(guest: Guest): BillingAddressFormState {
  const street = [guest.street, guest.house_number].filter(Boolean).join(" ").trim();
  return {
    override: false,
    company_name: guest.company_name ?? "",
    name: `${guest.first_name} ${guest.last_name}`.trim(),
    street: street || guest.street || "",
    postal_code: guest.postal_code ?? "",
    city: guest.city ?? "",
    country_code: guest.country_code ?? "DE",
  };
}

export function invoiceToBillingAddressForm(invoice: Invoice): BillingAddressFormState {
  return {
    override: invoice.billing_address_override ?? false,
    company_name: invoice.billing_company_name ?? "",
    name: invoice.billing_name ?? "",
    street: invoice.billing_street ?? "",
    postal_code: invoice.billing_postal_code ?? "",
    city: invoice.billing_city ?? "",
    country_code: invoice.billing_country_code ?? "DE",
  };
}

export function billingAddressToPayload(
  form: BillingAddressFormState,
): InvoiceBillingAddressPayload {
  if (!form.override) {
    return {
      override: false,
      company_name: null,
      name: "",
      street: "",
      postal_code: "",
      city: "",
      country_code: "DE",
    };
  }
  return {
    override: true,
    company_name: form.company_name.trim() || null,
    name: form.name.trim(),
    street: form.street.trim(),
    postal_code: form.postal_code.trim(),
    city: form.city.trim(),
    country_code: form.country_code.trim() || "DE",
  };
}

export function validateBillingAddressForm(form: BillingAddressFormState): string | null {
  if (!form.override) return null;
  if (!form.name.trim()) return "Bitte den Empfängernamen eingeben.";
  if (!form.street.trim()) return "Bitte die Straße eingeben.";
  if (!form.postal_code.trim() || !form.city.trim()) return "Bitte PLZ und Ort eingeben.";
  return null;
}
